'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';

// UI
import { Typography } from '@components/typography';
type Props = {
  reviewSummary: string;
};
export const SavvyReviewSummary: React.FC<Props> = t0 => {
  const $ = _c(4);
  const {
    reviewSummary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      border: "1.5px solid transparent",
      backgroundImage: "linear-gradient(white, white), linear-gradient(to right, #ef4444, #f97316, #eab308, #22c55e, #3b82f6, #a855f7)",
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between space-y-2 lg:space-y-0"><div className="flex items-center space-x-2"><Typography variant="body1" component="h3" className="font-semibold text-primary-main text-base">✨ What guests are saying</Typography></div><div><Typography variant="body2" component="span" className="text-gray-main font-normal text-base lg:text-xs xl:text-base">AI summary from real reviews</Typography></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reviewSummary) {
    t3 = <div className="rounded-lg p-4 space-y-4 relative" style={t1}>{t2}<div><Typography variant="body2" variantM="body1" component="p" className="text-primary-main">{reviewSummary}</Typography></div></div>;
    $[2] = reviewSummary;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};